var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6741 5.24947C16.8056 4.25017 19.1943 4.25018 21.3258 5.24947L31.3626 9.95496C33.5458 10.9785 33.5458 14.5216 31.3626 15.5451L21.3259 20.2505C19.1944 21.2498 16.8057 21.2498 14.6742 20.2505L4.6374 15.545C2.4542 14.5215 2.4542 10.9784 4.63741 9.95489L14.6741 5.24947Z",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75V21",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 17.25V24.9381C28.5 26.4502 27.7447 27.8658 26.422 28.5983C24.2194 29.8181 20.694 31.5 18 31.5C15.306 31.5 11.7806 29.8181 9.578 28.5983C8.25525 27.8658 7.5 26.4502 7.5 24.9381V17.25",
    stroke: "currentColor",
    strokeOpacity: 0.86,
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStudent);
export default __webpack_public_path__ + "static/media/ic_student.2f96151336ea70effa8a780278cff7ed.svg";
export { ForwardRef as ReactComponent };